// extracted by mini-css-extract-plugin
export default {"servicos":"Servicos_servicos__MOUbw"};